module.exports = __webpack_public_path__ + "img/utilityvalve_driving.4caa3bea.svg";